/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/NewsEntryCommentReportPaginationSlice', 'model/NewsEntryContributorPaginationSlice', 'model/NewsEntryInsightLink', 'model/NewsEntrySourceReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./NewsEntryCommentReportPaginationSlice'), require('./NewsEntryContributorPaginationSlice'), require('./NewsEntryInsightLink'), require('./NewsEntrySourceReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.NewsEntryFullReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.NewsEntryCommentReportPaginationSlice, root.ForStractionServiceApi.NewsEntryContributorPaginationSlice, root.ForStractionServiceApi.NewsEntryInsightLink, root.ForStractionServiceApi.NewsEntrySourceReport);
  }
}(this, function(ApiClient, NewsEntryCommentReportPaginationSlice, NewsEntryContributorPaginationSlice, NewsEntryInsightLink, NewsEntrySourceReport) {
  'use strict';




  /**
   * The NewsEntryFullReport model module.
   * @module model/NewsEntryFullReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>NewsEntryFullReport</code>.
   * @alias module:model/NewsEntryFullReport
   * @class
   */
  var exports = function() {
    var _this = this;






































  };

  /**
   * Constructs a <code>NewsEntryFullReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/NewsEntryFullReport} obj Optional instance to populate.
   * @return {module:model/NewsEntryFullReport} The populated <code>NewsEntryFullReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('SourceCategoryID')) {
        obj['SourceCategoryID'] = ApiClient.convertToType(data['SourceCategoryID'], 'Integer');
      }
      if (data.hasOwnProperty('SourceStakeholderTypeID')) {
        obj['SourceStakeholderTypeID'] = ApiClient.convertToType(data['SourceStakeholderTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('UserStatusID')) {
        obj['UserStatusID'] = ApiClient.convertToType(data['UserStatusID'], 'Integer');
      }
      if (data.hasOwnProperty('TimeStamp')) {
        obj['TimeStamp'] = ApiClient.convertToType(data['TimeStamp'], 'Date');
      }
      if (data.hasOwnProperty('Comments')) {
        obj['Comments'] = NewsEntryCommentReportPaginationSlice.constructFromObject(data['Comments']);
      }
      if (data.hasOwnProperty('Contributors')) {
        obj['Contributors'] = NewsEntryContributorPaginationSlice.constructFromObject(data['Contributors']);
      }
      if (data.hasOwnProperty('Source')) {
        obj['Source'] = NewsEntrySourceReport.constructFromObject(data['Source']);
      }
      if (data.hasOwnProperty('PESTELAreaName')) {
        obj['PESTELAreaName'] = ApiClient.convertToType(data['PESTELAreaName'], 'String');
      }
      if (data.hasOwnProperty('StakeholderName')) {
        obj['StakeholderName'] = ApiClient.convertToType(data['StakeholderName'], 'String');
      }
      if (data.hasOwnProperty('CompanyLegalEntityName')) {
        obj['CompanyLegalEntityName'] = ApiClient.convertToType(data['CompanyLegalEntityName'], 'String');
      }
      if (data.hasOwnProperty('CompanyFunctionName')) {
        obj['CompanyFunctionName'] = ApiClient.convertToType(data['CompanyFunctionName'], 'String');
      }
      if (data.hasOwnProperty('InsightLinks')) {
        obj['InsightLinks'] = ApiClient.convertToType(data['InsightLinks'], [NewsEntryInsightLink]);
      }
      if (data.hasOwnProperty('CategoryID')) {
        obj['CategoryID'] = ApiClient.convertToType(data['CategoryID'], 'Integer');
      }
      if (data.hasOwnProperty('SourceID')) {
        obj['SourceID'] = ApiClient.convertToType(data['SourceID'], 'Integer');
      }
      if (data.hasOwnProperty('EntryStatusID')) {
        obj['EntryStatusID'] = ApiClient.convertToType(data['EntryStatusID'], 'Integer');
      }
      if (data.hasOwnProperty('Title')) {
        obj['Title'] = ApiClient.convertToType(data['Title'], 'String');
      }
      if (data.hasOwnProperty('Subtitle')) {
        obj['Subtitle'] = ApiClient.convertToType(data['Subtitle'], 'String');
      }
      if (data.hasOwnProperty('PreviewImageURI')) {
        obj['PreviewImageURI'] = ApiClient.convertToType(data['PreviewImageURI'], 'String');
      }
      if (data.hasOwnProperty('DrillToURI')) {
        obj['DrillToURI'] = ApiClient.convertToType(data['DrillToURI'], 'String');
      }
      if (data.hasOwnProperty('DrillToText')) {
        obj['DrillToText'] = ApiClient.convertToType(data['DrillToText'], 'String');
      }
      if (data.hasOwnProperty('ContentText')) {
        obj['ContentText'] = ApiClient.convertToType(data['ContentText'], 'String');
      }
      if (data.hasOwnProperty('ContentImageURI')) {
        obj['ContentImageURI'] = ApiClient.convertToType(data['ContentImageURI'], 'String');
      }
      if (data.hasOwnProperty('AddedByUserID')) {
        obj['AddedByUserID'] = ApiClient.convertToType(data['AddedByUserID'], 'Integer');
      }
      if (data.hasOwnProperty('AddedTimeStamp')) {
        obj['AddedTimeStamp'] = ApiClient.convertToType(data['AddedTimeStamp'], 'Date');
      }
      if (data.hasOwnProperty('ApprovedByUserID')) {
        obj['ApprovedByUserID'] = ApiClient.convertToType(data['ApprovedByUserID'], 'Integer');
      }
      if (data.hasOwnProperty('ApprovedTimeStamp')) {
        obj['ApprovedTimeStamp'] = ApiClient.convertToType(data['ApprovedTimeStamp'], 'Date');
      }
      if (data.hasOwnProperty('RawContentPromotionLevel')) {
        obj['RawContentPromotionLevel'] = ApiClient.convertToType(data['RawContentPromotionLevel'], 'Integer');
      }
      if (data.hasOwnProperty('BingKeywords')) {
        obj['BingKeywords'] = ApiClient.convertToType(data['BingKeywords'], 'String');
      }
      if (data.hasOwnProperty('ModeratorID')) {
        obj['ModeratorID'] = ApiClient.convertToType(data['ModeratorID'], 'Integer');
      }
      if (data.hasOwnProperty('SWOTTopicID')) {
        obj['SWOTTopicID'] = ApiClient.convertToType(data['SWOTTopicID'], 'Integer');
      }
      if (data.hasOwnProperty('PersonalTopicID')) {
        obj['PersonalTopicID'] = ApiClient.convertToType(data['PersonalTopicID'], 'Integer');
      }
      if (data.hasOwnProperty('TrendTopicID')) {
        obj['TrendTopicID'] = ApiClient.convertToType(data['TrendTopicID'], 'Integer');
      }
      if (data.hasOwnProperty('StakeholderID')) {
        obj['StakeholderID'] = ApiClient.convertToType(data['StakeholderID'], 'Integer');
      }
      if (data.hasOwnProperty('CompanyLegalEntityID')) {
        obj['CompanyLegalEntityID'] = ApiClient.convertToType(data['CompanyLegalEntityID'], 'Integer');
      }
      if (data.hasOwnProperty('CompanyFunctionID')) {
        obj['CompanyFunctionID'] = ApiClient.convertToType(data['CompanyFunctionID'], 'Integer');
      }
      if (data.hasOwnProperty('PESTELAreaID')) {
        obj['PESTELAreaID'] = ApiClient.convertToType(data['PESTELAreaID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} SourceCategoryID
   * @default 0
   */
  exports.prototype['SourceCategoryID'] = 0;
  /**
   * @member {Integer} SourceStakeholderTypeID
   */
  exports.prototype['SourceStakeholderTypeID'] = undefined;
  /**
   * @member {Integer} UserStatusID
   */
  exports.prototype['UserStatusID'] = undefined;
  /**
   * @member {Date} TimeStamp
   */
  exports.prototype['TimeStamp'] = undefined;
  /**
   * @member {module:model/NewsEntryCommentReportPaginationSlice} Comments
   */
  exports.prototype['Comments'] = undefined;
  /**
   * @member {module:model/NewsEntryContributorPaginationSlice} Contributors
   */
  exports.prototype['Contributors'] = undefined;
  /**
   * @member {module:model/NewsEntrySourceReport} Source
   */
  exports.prototype['Source'] = undefined;
  /**
   * @member {String} PESTELAreaName
   * @default ''
   */
  exports.prototype['PESTELAreaName'] = '';
  /**
   * @member {String} StakeholderName
   * @default ''
   */
  exports.prototype['StakeholderName'] = '';
  /**
   * @member {String} CompanyLegalEntityName
   * @default ''
   */
  exports.prototype['CompanyLegalEntityName'] = '';
  /**
   * @member {String} CompanyFunctionName
   * @default ''
   */
  exports.prototype['CompanyFunctionName'] = '';
  /**
   * @member {Array.<module:model/NewsEntryInsightLink>} InsightLinks
   */
  exports.prototype['InsightLinks'] = undefined;
  /**
   * @member {Integer} CategoryID
   * @default 0
   */
  exports.prototype['CategoryID'] = 0;
  /**
   * @member {Integer} SourceID
   */
  exports.prototype['SourceID'] = undefined;
  /**
   * @member {Integer} EntryStatusID
   * @default 0
   */
  exports.prototype['EntryStatusID'] = 0;
  /**
   * @member {String} Title
   * @default ''
   */
  exports.prototype['Title'] = '';
  /**
   * @member {String} Subtitle
   * @default ''
   */
  exports.prototype['Subtitle'] = '';
  /**
   * @member {String} PreviewImageURI
   * @default ''
   */
  exports.prototype['PreviewImageURI'] = '';
  /**
   * @member {String} DrillToURI
   * @default ''
   */
  exports.prototype['DrillToURI'] = '';
  /**
   * @member {String} DrillToText
   * @default ''
   */
  exports.prototype['DrillToText'] = '';
  /**
   * @member {String} ContentText
   * @default ''
   */
  exports.prototype['ContentText'] = '';
  /**
   * @member {String} ContentImageURI
   * @default ''
   */
  exports.prototype['ContentImageURI'] = '';
  /**
   * @member {Integer} AddedByUserID
   */
  exports.prototype['AddedByUserID'] = undefined;
  /**
   * @member {Date} AddedTimeStamp
   */
  exports.prototype['AddedTimeStamp'] = undefined;
  /**
   * @member {Integer} ApprovedByUserID
   */
  exports.prototype['ApprovedByUserID'] = undefined;
  /**
   * @member {Date} ApprovedTimeStamp
   */
  exports.prototype['ApprovedTimeStamp'] = undefined;
  /**
   * @member {Integer} RawContentPromotionLevel
   * @default 0
   */
  exports.prototype['RawContentPromotionLevel'] = 0;
  /**
   * @member {String} BingKeywords
   * @default ''
   */
  exports.prototype['BingKeywords'] = '';
  /**
   * @member {Integer} ModeratorID
   * @default 0
   */
  exports.prototype['ModeratorID'] = 0;
  /**
   * @member {Integer} SWOTTopicID
   */
  exports.prototype['SWOTTopicID'] = undefined;
  /**
   * @member {Integer} PersonalTopicID
   */
  exports.prototype['PersonalTopicID'] = undefined;
  /**
   * @member {Integer} TrendTopicID
   */
  exports.prototype['TrendTopicID'] = undefined;
  /**
   * @member {Integer} StakeholderID
   */
  exports.prototype['StakeholderID'] = undefined;
  /**
   * @member {Integer} CompanyLegalEntityID
   */
  exports.prototype['CompanyLegalEntityID'] = undefined;
  /**
   * @member {Integer} CompanyFunctionID
   */
  exports.prototype['CompanyFunctionID'] = undefined;
  /**
   * @member {Integer} PESTELAreaID
   */
  exports.prototype['PESTELAreaID'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


